<template>
  <div class="page">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>{{ $t("system_user_modules_yinsishezhi") }}</span>
    </header-bar>
    <div class="page-content" style="background-color: #FFF;text-align:left;" ref="contractContent">
      <br />
      <van-cell center :title="$t('system_user_modules_gexinghuatuijian')">
        <template #label>{{ $t("system_user_modules_gexinghuaguanbi") }}<a @click="isShowRec = true" href="#">详情</a> </template>
        <template #right-icon>
          <van-switch v-model="privacyChecked" inactive-color="#ee0a24" size="24" />
        </template>
      </van-cell>
      <van-cell center :title="$t('login_yinsizhengce')" is-link @click="gotoPrivacy" />
    </div>

    <van-dialog v-model="isShowRec" :title="$t('system_user_modules_gexinghuatuijian')" @cancel="isShowRec = false">
      <div style="padding:10px">
        为向您推荐更契合您需求的个性化产品/服务，提升您的用户体验，我们可能会使用到您如下信息：您在访问或使用我们网站和客户端时的浏览记录、搜索记录、地理位置、设备信息（包括设备制造商、屏幕宽高、设备类型、设备识别符），以及其他取得您授权的信息。我们会基于以上信息进行综合统计、以便了解您的喜好特征，从而向您推荐更契合您需求的个性化产品/服务，提升您的用户体验。
        <!-- 如果您不喜欢个性化推荐的产品/服务，您可以通过在“我的”-“设置”-“隐私设置”-“个性推荐”中点击相应按钮进行关闭，关闭后您在APP内无法看到基于您的个人特征提供的针对性的推荐产品，从而影响您的用户体验，但不会影响您使用携程平台的基本功能，如需要您可再次开启。 -->
      </div>
    </van-dialog>
  </div>
</template>
<style scoped>
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 0.38rem;
  }
  .header-menu header {
    background-color: #12a3ff;
  }
  .page-content {
    top: 2.12rem;
  }
</style>
<script>
  import navBar from "../modules/navBar.vue";
  import { Cell, Dialog, Switch } from "vant";
  export default {
    name: "about",
    components: {
      navBar,
      [Cell.name]: Cell,
      [Dialog.name]: Dialog,
      [Switch.name]: Switch,
    },
    data() {
      let privacyChecked = localStorage.getItem("privacyChecked") !== "false";
      return { checked: privacyChecked, isShowRec: false };
    },
    methods: {
      gotoPrivacy() {
        this.$router.push("/system/privacyPolicy");
      },
    },

    computed: {
      privacyChecked: {
        get() {
          return this.checked;
        },
        set(value) {
          let isChecked = value === true ? "true" : "false";
          this.checked = value;
          // console
          localStorage.setItem("privacyChecked", isChecked);
        },
      },
    },
  };
</script>
